import Vue from 'vue';
import Vuex from 'vuex';
import storeLocal from 'storejs';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 存储token
    token: storeLocal.get('token') ? storeLocal.get('token') : '',
    identity: storeLocal.get('identity') ? storeLocal.get('identity') : '',
  },
  mutations: {
    changeLogin (state, user) {
      state.token = user.Authorization;
      storeLocal.set('token', user.Authorization);
    }
  },
  actions: {
  },
  modules: {
  }
})
